import { ProductBannerContainer } from './ProductBanner.style';
import LogoReckeweg from '../../assets/Products/Logos/dr-reckeweg-white.png';

const ProductBanner = () => {
    return (
        <ProductBannerContainer>
            <img src={LogoReckeweg} alt="Logo" />
        </ProductBannerContainer>
    );
}

export default ProductBanner;